import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MobileMenu from "../components/MobileMenu";
import Overlay from "../components/Overlay";
import Footer from "../components/Footer";
import Header from "../components/Header";
import { cartitem, Project } from "../type";
import { useAuth } from "../contexts/AuthContext";
import api from "../services/api";
import Toast from "../components/toast";

export default function Cart() {
    const { isAuthenticated, accessToken, loading: loadingauth } = useAuth();
    const navigate = useNavigate();

    const [menuOpen, setMenuOpen] = useState(false);
    const [activeTab, setActiveTab] = useState("cart");

    const [cart, setCart] = useState<cartitem[]>();
    const [totalprice, setTotalprice] = useState<number>();
    const [walletBalance, setWalletBalance] = useState(0);
    const [loading, setLoading] = useState(true);

    const [popupOpen, setPopupOpen] = useState(false);
    const [popupOpenSubmit, setPopupOpenSubmit] = useState(false);
    const [itemtodelete, setItemtodelete] = useState<cartitem>();

    const [toast, setToast] = useState<{ title: string, text: string }>();
    const [toastshow, setToastshow] = useState(false);

    const fetchcart = async () => {
        try {
            const mainRes = await api.get("/cart", {
                headers: {
                    Authorization: accessToken
                        ? `Bearer ${accessToken}`
                        : "",
                },
            })

            if (mainRes.data?.data.cart_items) {
                setCart(mainRes.data.data.cart_items);
                setTotalprice(mainRes.data.data.total_amount);
            }

        } catch (err) {
            console.log("cart fetch error:", err);
        } finally {
            setLoading(false);
        }
    };

    const fetchwalletBalance = async () => {
        try {
            const mainRes = await api.get("/wallet/balance", {
                headers: {
                    Authorization: accessToken
                        ? `Bearer ${accessToken}`
                        : "",
                },
            })

            if (mainRes.data?.balance) {
                setWalletBalance(mainRes.data.balance);
            }

        } catch (err) {
            console.log("cart fetch error:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (loadingauth) return;

        if (!isAuthenticated) {
            navigate('/');
            return;
        }

        fetchcart();
        fetchwalletBalance();

    }, [isAuthenticated, accessToken, loadingauth]);

    const formatPersianDate = (dateString: string): string | undefined => {
        if (!dateString) return undefined;

        const date = new Date(dateString);

        if (isNaN(date.getTime())) {
            console.warn('Invalid date:', dateString);
            return undefined;
        }

        try {
            return new Intl.DateTimeFormat('fa-IR', {
                calendar: 'persian',
                month: 'long',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
            }).format(date);
        } catch (err) {
            console.warn('Intl persian calendar not supported, falling back:', err);
            try {
                return new Intl.DateTimeFormat('fa-IR', {
                    month: 'long',
                    day: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                }).format(date);
            } catch {
                return date.toLocaleDateString();
            }
        }
    };

    const handeldelete = async (item: cartitem) => {
        try {
            const Res = await api.post("/cart/remove", {
                product_id: item.product_id,
                session_id: item.session_id,
            }, {
                headers: {
                    Authorization: accessToken
                        ? `Bearer ${accessToken}`
                        : "",
                },
            })

            if (Res.status === 200) {
                fetchcart();
                setPopupOpen(false);
                setToastshow(true);
                setToast({ title: 'موفقیت', text: "با موفقیت آیتم از سبد خرید حذف شد." });
            }
        } catch (err) {
            console.log("cart update error:", err);
        }
    }

    const deductfromitem = async (item: cartitem) => {
        try {
            const Res = await api.put("/cart", {
                product_id: item.product_id,
                session_id: item.session_id,
                quantity: (item.quantity - 1)
            }, {
                headers: {
                    Authorization: accessToken
                        ? `Bearer ${accessToken}`
                        : "",
                },
            })

            if (Res.status === 200) {
                fetchcart();
                setPopupOpen(false);
                setToastshow(true);
                setToast({ title: 'موفقیت', text: "با موفقیت تعداد کاهش پیدا کرد." });
            }
        } catch (err) {
            console.log("cart update error:", err);
        }
    }

    const onclicksubmit = async () => {
        if (!cart?.length || !totalprice) {
            setToastshow(true);
            setToast({ title: 'خطا', text: "سبد خرید شما خالی است." });
        } else if (walletBalance < totalprice) {
            setToastshow(true);
            setToast({ title: 'خطا', text: "موجودی کیف پول شما کمتر از مبلغ خرید است." });
        } else {
            setPopupOpenSubmit(true);
        }
    }

    const handelsubmit = async () => {
        try {
            const Res = await api.post("/cart/checkout", {}, {
                headers: {
                    Authorization: accessToken
                        ? `Bearer ${accessToken}`
                        : "",
                },
            })

            if (Res.status === 200) {
                fetchcart();
                setPopupOpenSubmit(false);
                setToastshow(true);
                setToast({ title: 'موفقیت', text: "با موفقیت خرید ثبت شد." });
            }
        } catch (err) {
            console.log("cart update error:", err);
        }
    }

    return (
        <>
            <div dir="rtl" className="min-h-dvh bg-darkbg">
                <div className="relative w-full max-w-[450px] mx-auto min-h-dvh max-h-dvh flex flex-col gap-2 pb-[72px] overflow-x-hidden">
                    <Overlay active={menuOpen} close={() => setMenuOpen(false)} />
                    <MobileMenu active={menuOpen} />
                    <Header menuOpen={menuOpen} close={() => setMenuOpen(!menuOpen)} />

                    <div className="w-full flex flex-col items-center gap-1 justify-center min-h-[5vh]">
                        <h1 className="text-primary text-4xl font-bold whitespace-nowrap">سبد خرید</h1>
                        <p dir="rtl" className="text-gray-500 text-xs">{(totalprice !== undefined && totalprice !== 0) && totalprice.toLocaleString('fa') + ' تومان '} </p>
                    </div>

                    <section className="flex-1 overflow-y-auto mt-2">
                        <div className="grid grid-cols-2 gap-3 p-4 scrollbar-thin">
                            {cart && cart.length > 0 ? cart.map((item, index) => (
                                <div dir="rtl" key={index}
                                    className="bg-[#1c1c1c] relative h-[95px] flex flex-row-reverse rounded-xl select-none"
                                >
                                    <img className="absolute w-full h-[95px] rounded-xl" src={item.image || './assets/img/event1.png'} />
                                    <div className="relative z-10 w-full bg-primary/70 rounded-xl px-6 py-4">
                                        <h3 className="text-[18px] font-bold">{item.name}</h3>
                                        <p className="text-[13px]">{formatPersianDate(item.date)}</p>
                                        <p className="text-[13px] mt-1">{(item.quantity.toLocaleString())} نفر </p>
                                    </div>

                                    <button
                                        onClick={() => { setPopupOpen(true); setItemtodelete(item) }}
                                        className="absolute top-[10px] left-[10px] z-20 w-[30px] h-[30px] bg-[#202020] hover:bg-red-500 
                                    rounded-lg flex items-center justify-center transition-colors duration-300 focus:outline-none"
                                        aria-label="حذف از سبد خرید"
                                    >
                                        <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                                        </svg>
                                    </button>

                                </div>
                            )) :
                                <div className="rounded-2xl col-span-2 border border-dashed border-primary/20 bg-black/10 p-6 text-center text-white/60">
                                    ایتمی در سبد خرید نیست.
                                </div>
                            }
                        </div>
                    </section>

                    <div className="w-full flex justify-center min-h-fit mb-[2vh]">
                        <button onClick={() => onclicksubmit()} className="bg-primary text-[#0f0f0f] text-2xl px-7 py-2 
                                            rounded-2xl font-bold whitespace-nowrap">
                            ثبت خرید
                        </button>
                    </div>

                    {popupOpen && itemtodelete && (
                        itemtodelete.quantity == 1 ? (
                            <>
                                <div onClick={(e) => { if (e.target === e.currentTarget) setPopupOpen(false) }}
                                    className="fixed inset-0 backdrop-blur-lg bg-black/60 flex justify-center items-center z-[200]"
                                />
                                <div onClick={(e) => { if (e.target === e.currentTarget) setPopupOpen(false) }}
                                    className="fixed inset-0 flex justify-center items-center z-[210] animate-popupFade"
                                >
                                    <div className="w-11/12 md:w-[55%] max-w-2xl p-6 bg-[rgba(40,40,40,0.50)] rounded-[14px] overflow-hidden relative">
                                        <span onClick={() => setPopupOpen(false)}
                                            className="absolute cursor-pointer text-5xl text-gray-400 right-[10px] top-[0px]"
                                        >×</span>
                                        <div dir="rtl" className="w-full max-w-3xl ">
                                            <div className="flex flex-col justify-between mb-8">
                                                <h2 className="text-red-400 text-[20px] font-bold text-center">
                                                    حذف ایتم از سبد خرید
                                                </h2>
                                            </div>
                                            <span className="text-gray-300 text-[18px] font-bold">{itemtodelete.name}</span>
                                            <p className="text-gray-300 text-[15px] mb-[20px]">{formatPersianDate(itemtodelete.date)}</p>

                                            <div className="flex justify-between items-center gap-3 mt-4">
                                                <button
                                                    onClick={() => { handeldelete(itemtodelete) }}
                                                    className="bg-red-600 hover:bg-red-700 px-[20px] py-[16px] text-[18px] rounded-[10px] flex-1 text-white"
                                                >حذف</button>
                                                <button
                                                    onClick={() => { setPopupOpen(false); setItemtodelete(undefined); }}
                                                    className="bg-gray-300 hover:bg-gray-200 px-[20px] py-[16px] text-[18px] rounded-[10px] flex-1"
                                                >لغو</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        ) : (
                            <>
                                <div onClick={(e) => { if (e.target === e.currentTarget) setPopupOpen(false) }}
                                    className="fixed inset-0 backdrop-blur-lg bg-black/60 flex justify-center items-center z-[200]"
                                />
                                <div onClick={(e) => { if (e.target === e.currentTarget) setPopupOpen(false) }}
                                    className="fixed inset-0 flex justify-center items-center z-[210] animate-popupFade"
                                >
                                    <div className="w-11/12 md:w-[55%] max-w-2xl p-6 bg-[rgba(40,40,40,0.50)] rounded-[14px] overflow-hidden relative">
                                        <span onClick={() => setPopupOpen(false)}
                                            className="absolute cursor-pointer text-5xl text-gray-400 right-[10px] top-[0px]"
                                        >×</span>
                                        <div dir="rtl" className="w-full max-w-3xl ">
                                            <div className="flex flex-col justify-between mb-8">
                                                <h2 className="text-red-400 text-[20px] font-bold text-center">
                                                    حذف ایتم از سبد خرید
                                                </h2>
                                            </div>
                                            <span className="text-gray-200 text-xl font-bold mb-4">{itemtodelete.name}</span>
                                            <div className="flex justify-between items-center mb-8">
                                                <p className="text-gray-300 text-[16px]">{formatPersianDate(itemtodelete.date)}</p>
                                                <p className="text-gray-300 text-[16px]">{(itemtodelete.quantity)} نفر</p>
                                            </div>
                                            <div className="flex justify-between items-center gap-3 mt-4">
                                                <button
                                                    onClick={() => { handeldelete(itemtodelete) }}
                                                    className="bg-red-600 hover:bg-red-700 px-[20px] py-[16px] text-[18px] rounded-[10px] flex-1 text-gray-100"
                                                >حذف کامل</button>
                                                <button
                                                    onClick={() => { deductfromitem(itemtodelete) }}
                                                    className="bg-primary/70 hover:bg-primary/75 px-[20px] py-[16px] text-[18px] rounded-[10px] flex-1 text-gray-100"
                                                >کاهش تعداد</button>
                                                <button
                                                    onClick={() => { setPopupOpen(false); setItemtodelete(undefined); }}
                                                    className="bg-gray-300 hover:bg-gray-200 px-[20px] py-[16px] text-[18px] rounded-[10px] flex-1"
                                                >لغو</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )
                    )}

                    {popupOpenSubmit &&
                        <>
                            <div onClick={(e) => { if (e.target === e.currentTarget) setPopupOpenSubmit(false) }}
                                className="fixed inset-0 backdrop-blur-lg bg-black/60 flex justify-center items-center z-[200]"
                            />
                            <div onClick={(e) => { if (e.target === e.currentTarget) setPopupOpenSubmit(false) }}
                                className="fixed inset-0 flex justify-center items-center z-[210] animate-popupFade"
                            >
                                <div className="w-11/12 md:w-[55%] max-w-2xl p-6 bg-[rgba(40,40,40,0.50)] rounded-[14px] overflow-hidden relative">
                                    <span onClick={() => setPopupOpenSubmit(false)}
                                        className="absolute cursor-pointer text-5xl text-gray-400 right-[10px] top-[0px]"
                                    >×</span>
                                    <div dir="rtl" className="w-full max-w-3xl ">
                                        <div className="flex flex-col justify-between mb-4">
                                            <h2 className="text-primary text-[20px] font-bold text-center">
                                                ثبت سفارشات
                                            </h2>
                                        </div>
                                        <p className="text-gray-300 text-[16px] text-center font-bold mb-8">از ثبت خرید و سفارش خود اطمینان دارید؟</p>

                                        <div className="flex justify-between items-center gap-3 mt-4">
                                            <button
                                                onClick={() => { handelsubmit() }}
                                                className="bg-primary hover:bg-primary/85 px-[20px] py-[16px] text-[18px] rounded-[10px] flex-1"
                                            >تایید</button>
                                            <button
                                                onClick={() => { setPopupOpenSubmit(false) }}
                                                className="bg-gray-300 hover:bg-gray-200 px-[20px] py-[16px] text-[18px] rounded-[10px] flex-1"
                                            >لغو</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    }

                    <Toast active={toastshow} title={toast?.title} text={toast?.text} setToastshow={setToastshow} />
                    <Footer activeTab={activeTab} setActiveTab={setActiveTab} />
                </div>
            </div>
        </>
    );
}